import template from "./password.html";
import {passwordController} from "./password.controller";

const PasswordComponent = {
	template,
	controller: passwordController,
	controllerAs: "password"
};

export default PasswordComponent;


// WEBPACK FOOTER //
// ./sources/components/auth/password/password.component.js